import { useEffect, type ReactNode } from 'react';
import { setOnNoAutenticat, setTokenProvider } from '@/api/client';
import { config } from '@/config/env';
import { useAuth } from './AuthContext';
import { MockAuthProvider } from './MockAuthProvider';
import { MsalAuthProvider } from './MsalAuthProvider';

function RegistraToken({ children }: { children: ReactNode }) {
  const { obteToken, login } = useAuth();
  useEffect(() => {
    setTokenProvider(obteToken);
  }, [obteToken]);
  useEffect(() => {
    // Qualsevol 401 de l'API (token caducat o revocat) torna a demanar la sessió.
    setOnNoAutenticat(() => void login());
    return () => setOnNoAutenticat(() => {});
  }, [login]);
  return <>{children}</>;
}

export function AuthProvider({ children }: { children: ReactNode }) {
  const Proveidor = config.authMode === 'mock' ? MockAuthProvider : MsalAuthProvider;
  return (
    <Proveidor>
      <RegistraToken>{children}</RegistraToken>
    </Proveidor>
  );
}
